import { ContentType } from "@pdfking/structs"
import { Constant, FullMethodDispatcher } from "@pdfking/tfunc"

import type { VirtualFile } from "#public"

import { VirtualFileType } from "../types/files/VirtualFileType"

export const FileContentType = FullMethodDispatcher<[VirtualFile], ContentType>({
  [VirtualFileType.MULTI_PAGE_PDF]: Constant(ContentType.PDF),
  [VirtualFileType.REMOTE_FILE]: file => file.type,
  // Rasterized (webp/png by platform) or separated (tiff): whatever was stored
  [VirtualFileType.SINGLE_PAGE_IMAGE]: file => file.content.type,
  [VirtualFileType.BINARY_PAGE_PDF]: Constant(ContentType.PDF),
  [VirtualFileType.PLOTTED_PAGE_PDF]: Constant(ContentType.PDF),
  [VirtualFileType.ZIP_FILE]: Constant(ContentType.ZIP),
})
